/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

module.exports = baseToString;



/*****************
 ** WEBPACK FOOTER
 ** ./~/normalizr/~/lodash/internal/baseToString.js
 ** module id = 1100
 ** module chunks = 0
 **/